import { connect } from 'react-redux';
import PPA from './PPA';

import {
    setPPAEscalator,
    setPPARate,
    setPPATerm,
    setShowPPA,
} from '../../common/ppa/actions';

import { setPpaIsVisible } from './actions';

import { setSelectedFinancing } from '../../common/settings/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    isVisible: state.ppaUI.isVisible,
    solarValue: state.solar.solarValue,
    showPPA: state.ppa.showPPA,
    resiToggle: state.tax.resiToggle,
    setSelectedFinancing,
    setPpaIsVisible,
    setPPAEscalator,
    setPPATerm,
    setPPARate,
    setShowPPA,
});

const combinedActions = {
    setPPAEscalator,
    setPPARate,
    setPPATerm,
    setPpaIsVisible,
    setShowPPA,
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(PPA);



// WEBPACK FOOTER //
// ./src/containers/Inputs/PPA/index.js